import * as angular from "angular";
import {IController} from "angular";

export class BringozDayOfWeekSelectComponent implements IController {
  selectedDay: string;
  isDisabled: any;
  onChange: Function;

  dayKeys: string[];

  constructor(private commonsConstants) {
  }

  $onInit() {
    this.dayKeys = Object.keys(this.commonsConstants.daysCheckboxConfig);
  }

  selectDay(dayKey: string) {
    if (this.isDisabled) {
      return;
    }

    this.selectedDay = dayKey;
    this.onChange({dayKey});
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozDayOfWeekSelect', {
    bindings: {
      selectedDay: '<',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./bringoz-day-of-week-select.html').default,
    controller: BringozDayOfWeekSelectComponent
  });
